/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabCommentContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_settings" | "CommentContainer_settings">;
    readonly " $refType": "AllCommentsTabCommentContainer_settings";
};
export type AllCommentsTabCommentContainer_settings$data = AllCommentsTabCommentContainer_settings;
export type AllCommentsTabCommentContainer_settings$key = {
    readonly " $data"?: AllCommentsTabCommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '62fa574fc03fa4c041ce8aaef05f64d9';
export default node;
